import Button from "@components/Button";
import type { TTSBlock } from "@components/TTSEditor/types";
import { Template } from "@components/Template";
import { toast } from "@components/Toaster";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import { http } from "@src/app/utils";
import { FaSolidPlay } from "solid-icons/fa";
import { Show, type VoidComponent, createSignal, onCleanup } from "solid-js";

const Preview: VoidComponent<{ blocks: TTSBlock[]; buttonDiameter?: string }> = (props) => {
	const { t } = useI18n();
	const [playing, setPlaying] = createSignal(false);
	const [controller, setController] = createSignal<AbortController>();
	const [audioSource, setAudioSource] = createSignal<AudioBufferSourceNode>();
	const [loading, setLoading] = createSignal(false);
	const handlePlay = () => {
		if (playing()) return;
		setPlaying(true);

		const blocks = props.blocks
			.filter((b) => b.text.length)
			.map<Omit<TTSBlock, "id">>((b) => ({
				...b,
				id: undefined,
			}));
		const audioCtx = new AudioContext();
		const c = new AbortController();
		setController(c);
		setLoading(true);
		http("tts/preview", "POST", blocks, { signal: c.signal })
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error, status = ${response.status}`);
				}
				return response.arrayBuffer();
			})
			.then((buffer) => audioCtx.decodeAudioData(buffer))
			.then((decodedData) => {
				const source = new AudioBufferSourceNode(audioCtx);
				source.buffer = decodedData;
				source.connect(audioCtx.destination);
				return source;
			})
			.then((source) => {
				setLoading(false);
				source.start(0);
				source.onended = () => setPlaying(false);
				setAudioSource(source);
			})
			.catch(() => {
				toast.error(t("app.tts.error"));
				setPlaying(false);
			});
	};
	onCleanup(() => {
		const c = controller();
		if (c) c.abort();
		audioSource()?.stop();
	});
	return (
		<>
			<Show
				when={loading()}
				fallback={
					<Button
						diameter={props.buttonDiameter ?? "35px"}
						disabled={playing() || props.blocks.reduce((p, c) => p + c.text.length, 0) < 3}
						onclick={handlePlay}
					>
						<FaSolidPlay font-size="15px" />
					</Button>
				}
			>
				<Template w={props.buttonDiameter ?? "35px"} h={props.buttonDiameter ?? "35px"} borderRadius="50%" />
			</Show>
		</>
	);
};
export default Preview;
